// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1OWuu","actionsCol":"EnrolledClinics_actionsCol__3gT0-"};